import getRemBase from 'propel/getRemBase';

const locationCards = document.querySelectorAll('.location-card');

const setCardCSSCustomProperties = (locationCard = null) => {
	let cards = locationCards;

	if (locationCard?.classList?.contains('location-card')) {
		cards = [locationCard];
	}

	cards.forEach((card) => {
		card.style.removeProperty('--card-min-height');
		card.style.setProperty(
			'--card-min-height',
			`${card.offsetHeight / getRemBase()}rem`
		);
		card.classList.add('location-card--initialized');
	});
};

setCardCSSCustomProperties();
